// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OLEoV6oK {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.CJELUOPt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 56px;
  background-color: #16213e;
  border-bottom: 1px solid #2a2a4a;
}

.NuE56w9H {
  font-size: 24px;
  font-weight: 700;
  color: #4ecca3;
  letter-spacing: 2px;
}

.NuE56w9H:hover {
  text-decoration: none;
}

.sGpISZpB {
  display: flex;
  gap: 16px;
}

.wbD7vDw3 {
  color: #888;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: color 0.2s;
}

.wbD7vDw3:hover {
  color: #e0e0e0;
  text-decoration: none;
}

.k4ehidKB {
  color: #4ecca3;
}

.yLUhCQmy {
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.ywnpVhaY {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  font-size: 12px;
  color: #555;
  border-top: 1px solid #2a2a4a;
  background-color: #1a1a2e;
}

.iynfYJt2 a {
  color: #4ecca3;
  text-decoration: none;
}

.iynfYJt2 a:hover {
  text-decoration: underline;
}

/* XpBar in header */
.Bvs1v2rC {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.puLyGB1X {
  color: #4ecca3;
  font-weight: 700;
  white-space: nowrap;
}

.As3HdUUz {
  width: 80px;
  height: 6px;
  background: #2a2a4a;
  border-radius: 3px;
  overflow: hidden;
}

.jj_CdAhJ {
  height: 100%;
  background: #4ecca3;
  border-radius: 3px;
  transition: width 0.3s;
}

.wElcXbqz {
  color: #888;
  white-space: nowrap;
}

.neGysjal {
  background: none;
  border: 1px solid #2a2a4a;
  color: #888;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: color 0.2s, border-color 0.2s;
}

.neGysjal:hover {
  color: #ff6b6b;
  border-color: #ff6b6b;
}

/* Responsive: 800px breakpoint */
@media (max-width: 800px) {
  .CJELUOPt {
    padding: 0 12px;
    height: 48px;
  }

  .NuE56w9H {
    font-size: 18px;
  }

  .sGpISZpB {
    gap: 8px;
  }

  .wbD7vDw3 {
    font-size: 12px;
    padding: 2px 4px;
  }

  .yLUhCQmy {
    padding: 12px;
  }

  .As3HdUUz {
    width: 50px;
  }

  .wElcXbqz {
    display: none;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .CJELUOPt {
    padding: 0 6px;
    height: 44px;
  }

  .NuE56w9H {
    font-size: 16px;
    letter-spacing: 1px;
  }

  .sGpISZpB {
    gap: 2px;
  }

  .wbD7vDw3 {
    font-size: 11px;
    padding: 2px 2px;
  }

  .yLUhCQmy {
    padding: 8px;
  }

  .ywnpVhaY {
    flex-direction: column;
    gap: 4px;
    padding: 8px;
  }

  .Bvs1v2rC {
    display: none;
  }

  .neGysjal {
    padding: 3px 6px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 56px;\n  background-color: #16213e;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.logo {\n  font-size: 24px;\n  font-weight: 700;\n  color: #4ecca3;\n  letter-spacing: 2px;\n}\n\n.logo:hover {\n  text-decoration: none;\n}\n\n.nav {\n  display: flex;\n  gap: 16px;\n}\n\n.link {\n  color: #888;\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: color 0.2s;\n}\n\n.link:hover {\n  color: #e0e0e0;\n  text-decoration: none;\n}\n\n.activeLink {\n  composes: link;\n  color: #4ecca3;\n}\n\n.main {\n  flex: 1;\n  padding: 24px;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  font-size: 12px;\n  color: #555;\n  border-top: 1px solid #2a2a4a;\n  background-color: #1a1a2e;\n}\n\n.footerCredits a {\n  color: #4ecca3;\n  text-decoration: none;\n}\n\n.footerCredits a:hover {\n  text-decoration: underline;\n}\n\n/* XpBar in header */\n.xpContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.xpLevel {\n  color: #4ecca3;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.xpTrack {\n  width: 80px;\n  height: 6px;\n  background: #2a2a4a;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.xpFill {\n  height: 100%;\n  background: #4ecca3;\n  border-radius: 3px;\n  transition: width 0.3s;\n}\n\n.xpTotal {\n  color: #888;\n  white-space: nowrap;\n}\n\n.logoutBtn {\n  background: none;\n  border: 1px solid #2a2a4a;\n  color: #888;\n  padding: 4px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.logoutBtn:hover {\n  color: #ff6b6b;\n  border-color: #ff6b6b;\n}\n\n/* Responsive: 800px breakpoint */\n@media (max-width: 800px) {\n  .header {\n    padding: 0 12px;\n    height: 48px;\n  }\n\n  .logo {\n    font-size: 18px;\n  }\n\n  .nav {\n    gap: 8px;\n  }\n\n  .link {\n    font-size: 12px;\n    padding: 2px 4px;\n  }\n\n  .main {\n    padding: 12px;\n  }\n\n  .xpTrack {\n    width: 50px;\n  }\n\n  .xpTotal {\n    display: none;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .header {\n    padding: 0 6px;\n    height: 44px;\n  }\n\n  .logo {\n    font-size: 16px;\n    letter-spacing: 1px;\n  }\n\n  .nav {\n    gap: 2px;\n  }\n\n  .link {\n    font-size: 11px;\n    padding: 2px 2px;\n  }\n\n  .main {\n    padding: 8px;\n  }\n\n  .footer {\n    flex-direction: column;\n    gap: 4px;\n    padding: 8px;\n  }\n\n  .xpContainer {\n    display: none;\n  }\n\n  .logoutBtn {\n    padding: 3px 6px;\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `OLEoV6oK`,
	"header": `CJELUOPt`,
	"logo": `NuE56w9H`,
	"nav": `sGpISZpB`,
	"link": `wbD7vDw3`,
	"activeLink": `k4ehidKB wbD7vDw3`,
	"main": `yLUhCQmy`,
	"footer": `ywnpVhaY`,
	"footerCredits": `iynfYJt2`,
	"xpContainer": `Bvs1v2rC`,
	"xpLevel": `puLyGB1X`,
	"xpTrack": `As3HdUUz`,
	"xpFill": `jj_CdAhJ`,
	"xpTotal": `wElcXbqz`,
	"logoutBtn": `neGysjal`
};
export default ___CSS_LOADER_EXPORT___;
